export const xs = "480px";
export const sm = "768px";
export const md = "992px";
export const lg = "1200px";
export default {
  "xs": "480px",
  "sm": "768px",
  "md": "992px",
  "lg": "1200px"
}
;